export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7658.631a2ba7.jpg";